import React from 'react'
import './avatar.css'

const Avatar = ({imgurl, isOnline}) => {
  return (
    <div className='img-avatar-container'>
        <div className='prt_image_container-1' style={{backgroundImage: `url(${process.env.PUBLIC_URL + imgurl})`}}/>
        <div id={isOnline === 'online' ? 'online' : 'offline'}/>
    </div>
  )
}

export default Avatar